import React, { useState, useEffect } from 'react';
import { Form, Button, Select } from 'antd';

const { Option } = Select;

const Pagination = ({ rowCount, pageNo, updateState, handleSearch, ...props}) => {
  const [ selectedBatch, setSelectedBatch ] = useState(pageNo);

  let pageNumbers = [];
  let totPages = rowCount / 100;
  // populate array for dropdown
  for (let i = 0; i < totPages; i++){
    pageNumbers.push(i);
  }

  const handleChangeBatch = () => {
    const { parameters } = props.state;
    parameters.pageNo = selectedBatch;
    updateState('parameters', parameters);
    handleSearch();
  }

  return (
    <Form>
      Select Batch:
      <Select
        defaultValue={0}
        onChange={(value) => setSelectedBatch(value)}
        style={{ width: 60, marginLeft: 5 }}
      >
        { pageNumbers.map((num) => {
          return <Option key={num} value={num}>{num}</Option>
        })}
      </Select>
      <Button type="primary" ghost size={'small'} style={{ marginLeft: 10 }}
        onClick={handleChangeBatch}
      >
        Change Batch
      </Button>
    </Form>
  );

}

export default Pagination;



// WEBPACK FOOTER //
// ./src/Components/Schedule/SelectCostObject/Pagination.js